import createRequestSlice, { requestInitialState } from 'redux/request/reducer';

export const PREFIX = 'buildings.editProject';

export const initialState = {
  ...requestInitialState,
  data: {},
  isLoading: false,
  hasError: false,
  isSuccess: false,
};

const editProjectSlice = createRequestSlice({
  name: PREFIX,
  initialState,
  reducers: {
    request(state) {
      return {
        ...state,
        hasError: false,
        isLoading: true,
        isSuccess: false,
      };
    },
    failure(state) {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    },
    fetch(state, { payload, meta }) {
      return {
        ...state,
        data: payload,
        hasError: false,
        isLoading: false,
      };
    },
    create(state) {
      return {
        ...state,
        hasError: false,
        isLoading: false,
        isSuccess: true,
      };
    },
    clearData() {
      return { ...initialState };
    },
  },
});

export const actions = { ...editProjectSlice.actions };
export const requests = { ...editProjectSlice.requests };

export default editProjectSlice.reducer;
